module.exports = __webpack_public_path__ + "media/images/sales/early/eyecatch-early-01-19dafa2bda84bd1f77175dbc006be2b8.svg";